import React from 'react';
import {AdminCompanyForm} from "./form";
import {BasicCreateForm} from "../../utils/proto/mixins/form/create";



export const AdminCompanyCreateForm =  AdminCompanyForm(BasicCreateForm('company'));